import type { QueryClient } from "@tanstack/react-query";
import {
  type ApiUserProfileIdContactsGetRequest,
  UserProfileApi,
} from "@/openapi/generated";
import { QueryKeys } from "@/lib/types";
import { createAuthenticatedApi } from "@/lib/utils";

export async function prefetchFamilyContactsGet(
  userId: number,
  queryClient: QueryClient,
  contactId?: number,
  accessToken?: string,
) {
  if (!accessToken) {
    throw new Error("Access token is required for prefetching family contacts");
  }

  const service = createAuthenticatedApi(UserProfileApi, accessToken);

  const params: ApiUserProfileIdContactsGetRequest = {
    id: userId,
    ...(contactId ? { ids: [contactId] } : {}),
  };

  await queryClient.prefetchQuery({
    queryKey: [QueryKeys.FamilyContactsGet, userId, contactId ?? "all"],
    queryFn: () => service.apiUserProfileIdContactsGet(params),
  });

  return queryClient;
}
